import { render, staticRenderFns } from "./ProfileUnblockUsersReveals.vue?vue&type=template&id=236b5c18&scoped=true&"
import script from "./ProfileUnblockUsersReveals.vue?vue&type=script&lang=js&"
export * from "./ProfileUnblockUsersReveals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236b5c18",
  null
  
)

export default component.exports